
import { Button } from "@/components/ui/button";
import { Share, Facebook, Twitter, Linkedin, Copy, Check } from "lucide-react";
import { useState } from "react";
import { useLanguage } from "@/components/LanguageContext";
import { toast } from "sonner";
import { useTranslations } from "@/hooks/useTranslations";

interface ShareProfileProps {
  profileUrl: string;
}

export const ShareProfile = ({ profileUrl }: ShareProfileProps) => {
  const { language } = useLanguage();
  const { t } = useTranslations("publicProfile");
  const [copied, setCopied] = useState(false);
  
  // Create the full URL with proper language path
  const baseUrl = window.location.origin;
  const fullUrl = language === 'pt' 
    ? `${baseUrl}/pt/pp/${profileUrl}`
    : `${baseUrl}/pp/${profileUrl}`;
  
  const copyToClipboard = () => {
    navigator.clipboard.writeText(fullUrl).then(() => {
      setCopied(true);
      toast.success(t("linkCopied"));
      setTimeout(() => setCopied(false), 2000);
    });
  };
  
  const shareOnFacebook = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(fullUrl)}`, '_blank');
  };
  
  const shareOnTwitter = () => {
    const text = t("checkOutProfile");
    window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(fullUrl)}`, '_blank');
  };
  
  const shareOnLinkedin = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(fullUrl)}`, '_blank');
  };
  
  return (
    <div className="flex flex-col space-y-4">
      <div className="flex items-center justify-center gap-2">
        <Button 
          onClick={copyToClipboard} 
          variant="outline" 
          size="sm" 
          className="flex items-center gap-2"
        >
          {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
          {copied ? t("copied") : t("copyLink")}
        </Button>
      </div>
      
      <div className="flex justify-center gap-2">
        <Button onClick={shareOnFacebook} variant="outline" size="icon" title={t("shareOnFacebook")}>
          <Facebook className="h-4 w-4" />
        </Button>
        <Button onClick={shareOnTwitter} variant="outline" size="icon" title={t("shareOnTwitter")}>
          <Twitter className="h-4 w-4" />
        </Button>
        <Button onClick={shareOnLinkedin} variant="outline" size="icon" title={t("shareOnLinkedin")}>
          <Linkedin className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
